import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function Footer() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-neutral-800">
      <div className="max-w-5xl mx-auto px-4 py-8 text-center text-sm">
        <div className="mb-3 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-neutral-300">
          <Link
            to="/privacy"
            className="hover:underline hover:text-white"
            aria-label={t("privacy.nav")}
          >
            {t("privacy.nav")}
          </Link>
          
          <Link
            to="/cookies"
            className="hover:underline hover:text-white"
            aria-label={t("cookies.nav")}
          >
            {t("cookies.nav")}
          </Link>
        </div>

        <div className="text-muted">{t("footer.rights", { year })}</div>
      </div>
    </footer>
  );
}
